module.exports = __webpack_public_path__ + "img/mgw-prestige-en.c8799a63.png";